import React from "react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { TECH } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const Technology = () => {
  const { t } = useLang();
  return (
    <section id="technology" data-testid="technology-section" className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 grid-bg grid-mask opacity-60 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading overline={t(TECH.overline)} title={t(TECH.title)} />
        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {TECH.groups.map((group, gi) => (
            <Reveal key={gi} delay={gi * 0.1}>
              <div className="rounded-2xl border border-white/[0.07] bg-[#0A0E17]/70 backdrop-blur p-7 h-full">
                <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-[#60A5FA]">{t(group.label)}</h3>
                <div className="mt-6 flex flex-wrap gap-2.5">
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm text-white/75 font-mono transition-all duration-300 hover:border-[#3B82F6]/50 hover:text-white hover:bg-[#3B82F6]/10 cursor-default"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
